let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cGi0u")).then(() => parcelRequire('bem9x'));